import { render, staticRenderFns } from "./GuestDocumentationTtcGroups.vue?vue&type=template&id=66943835&scoped=true&"
import script from "./GuestDocumentationTtcGroups.vue?vue&type=script&lang=js&"
export * from "./GuestDocumentationTtcGroups.vue?vue&type=script&lang=js&"
import style0 from "./GuestDocumentationTtcGroups.vue?vue&type=style&index=0&id=66943835&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66943835",
  null
  
)

export default component.exports